// Day-key helpers + small utilities for the in-game clock.
// The engine never reads wall-clock time itself — the store's time middleware
// converts elapsed real days into AdvanceDay actions. The engine just trusts the dayKey.

/** Returns "yyyy-mm-dd" for a Date in UTC. Stable across timezones. */
export function dayKeyFromDate(d: Date): string {
  const y = d.getUTCFullYear();
  const m = `${d.getUTCMonth() + 1}`.padStart(2, '0');
  const day = `${d.getUTCDate()}`.padStart(2, '0');
  return `${y}-${m}-${day}`;
}

/** Whole-day count from earlier dayKey to later dayKey. Returns 0 if same, negative if reversed. */
export function daysBetween(fromKey: string, toKey: string): number {
  const a = Date.parse(`${fromKey}T00:00:00Z`);
  const b = Date.parse(`${toKey}T00:00:00Z`);
  if (Number.isNaN(a) || Number.isNaN(b)) return 0;
  return Math.round((b - a) / 86_400_000);
}
